import { Timestamp } from "firebase/firestore";

function isDate(candidate: unknown): candidate is Date {
  return typeof (candidate as any)?.getMonth === "function";
}
function isTimestamp(candidate: unknown): candidate is Timestamp {
  return typeof (candidate as any)?.toDate === "function";
}

export const getDate = (input: unknown): Date | null => {
  if (isDate(input)) {
    return input;
  }
  if (isTimestamp(input)) {
    return input.toDate();
  }
  return null;
};
